import cn from 'classnames';
import IconPlusFaqDrawer from '../IconPlusFaqDrawer';

type QuestionProps = {
  question: string;
  onClick?: () => void;
  hasDarkBackground?: boolean;
  isOpen?: boolean;
};

export const Question = ({ question, onClick, hasDarkBackground, isOpen }: QuestionProps) => (
  <button onClick={onClick} className="w-full flex justify-between items-center gap-2 py-4 px-2 md:px-3">
    <div
      className={cn('text-p1 md:text-h2 font-500 text-left', {
        'text-white': hasDarkBackground,
        'text-black': !hasDarkBackground,
      })}
    >
      {question}
    </div>
    <div className="flex">
      <IconPlusFaqDrawer open={isOpen} darkBackground={hasDarkBackground} className="block" />
    </div>
  </button>
);
